module.exports = __webpack_public_path__ + "static/img/post_8.c6d3795.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blog/posts/post_8.png
// module id = WYIn
// module chunks = 0